module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_3009.85845d58.png";